// @flow
/* eslint-disable import/prefer-default-export */
import * as c from './constants';

const namespace = `@${c.MODULE_NAME}`;

export const SET_READY = `${namespace}/SET_READY`;
export const TRY_AUTHORIZE = `${namespace}/TRY_AUTHORIZE`;
export const BREAK_ACCESS_TOKEN = `${namespace}/BREAK_ACCESS_TOKEN`;
export const FETCH_USER_DATA = `${namespace}/FETCH_USER_DATA`;
export const RELOAD_AUTH_SESSION = `${namespace}/RELOAD_AUTH_SESSION`;

export const SET_USER = `${namespace}/SET_USER`;
export const SET_WALLET = `${namespace}/SET_WALLET`;
export const SET_ADVERTISER = `${namespace}/SET_ADVERTISER`;

export const AUTH_USER = `${namespace}/AUTH_USER`;
export const AUTH_USER_REQUESTED = `${namespace}/AUTH_USER_REQUESTED`;
export const AUTH_USER_SUCCESS = `${namespace}/AUTH_USER_SUCCESS`;
export const AUTH_USER_ERROR = `${namespace}/AUTH_USER_ERROR`;

export const UNAUTH_USER = `${namespace}/UNAUTH_USER`;
export const UNAUTH_USER_REQUESTED = `${namespace}/UNAUTH_USER_REQUESTED`;
export const UNAUTH_USER_SUCCESS = `${namespace}/UNAUTH_USER_SUCCESS`;
export const UNAUTH_USER_ERROR = `${namespace}/UNAUTH_USER_ERROR`;

export const REFRESH_TOKEN = `${namespace}/REFRESH_TOKEN`;
export const REFRESH_TOKEN_REQUESTED = `${namespace}/REFRESH_TOKEN_REQUESTED`;
export const REFRESH_TOKEN_SUCCESS = `${namespace}/REFRESH_TOKEN_SUCCESS`;
export const REFRESH_TOKEN_ERROR = `${namespace}/REFRESH_TOKEN_ERROR`;

export const SET_BILLING_INFO = `${namespace}/SET_BILLING_INFO`;



// WEBPACK FOOTER //
// ./src/modules/auth/types.js